export default {
  gw: {
    news: {
      title: "攻略&公告",
      strategyTab: "官方攻略",
      announcementTab: "公告资讯",
      prevPage: "上一页",
      nextPage: "下一页",
      returnBtn: "返回",
      returnList: "返回列表",
      prevArticle: "上一篇",
      nextArticle: "下一篇",
      noContent: "暂无内容",
      backToIndex: "返回官网",
      more: "更多",
    },
  },
  yy: {
    title: "策定九州",
    slogan: "新时代即时策略三国SLG",
    preRegister: "事前预约",
    giftTitle: "洛阳奖金赛",
    milestoneTitle: "关注领好礼",
    featureTitle: "进入官网",
    comingSoon: "敬请期待",
  },
  foot: {
    Notice: "注意事项",
    privacyPolicy: "隐私条款",
    termsOfService: "会员条款",
    EmailText: "客服邮箱：",
    copy: "复制成功",
    version: "Copyright© 2026 RASTAR GAMES (HK) CO., Ltd. All Rights Reserved",
  },
  alliance: {
    language_1: "请先加入/创建联盟",
    language_2: "抽数不足，请完成任务获取",
    language_3: "请先登录",
    language_4: "敬请期待",
    language_5: "复制成功",
    language_6: "复制失败，请尝试手动复制",
    language_7: "链接复制成功！快去邀请好友加入联盟吧",
    language_8: "预创盟活动已结束；点击底部【抽奖】>【我的奖励】领礼包码",
    footer: {
      language_1: "Rules",
      language_2: "Privacy Policy",
      language_3: "VIP Terms",
    },
    home: {
      language_1_1: "你好，【",
      language_1_2: "】",
      language_2: "联盟人数：",
      language_3: "联盟积分：",
      language_4: "现存联盟数:",
      language_5: "请输入备战盟ID或名称",
      // language_6: "ID ",
      language_7: "盟主",
      language_8: "联盟人数",
      language_9: "联盟宣言",
      language_10: "【登录】",
      create: {
        language_1: "请输入(不超过30字)",
        language_2: "请输入(不超过30字)",
        language_3: "请输入100个汉字以内的联盟宣言",
        language_4: "请输入群组链接",
      },
    },
    luckyDraw: {
      language_1: "剩余抽奖次数：",
    },
    quests: {
      language_1: "积分",
      language_2: "抽奖机会",
      language_3: "每日首次分享页面",
      language_4: "邀请好友参与",
      language_5: "前往商店预约",
      language_6: "关注官方FB",
      language_7: "加入官方discord",
    },
    confirmDialog: {
      language_1:
        "每个账号仅有 1 次 创建 / 加入同盟的机会，创建 / 加入该同盟后无法取消，是否确认？",
    },
    successDialog: {
      language_1: "恭喜您已经加入该联盟",
      language_2: "联盟创建成功",
      language_3: "完成联盟任务，获取积分与抽奖机会，赢取丰厚奖励！",
    },
    myRewardsDialog: {
      language_1: "人",
      language_2: "聚义令 x",
    },
    preSelectedServerDialog: {
      language_1: "服务器",
      language_2:
        "※请务必使用参与预建联盟活动的同一 RASTAR GAMES 账号登录游戏。公测开启后 6 小时内使用该账号创建角色，即可直接进入所选服务器，不受服务器状态限制。每个服务器仅开放 3 个预创盟预选入驻名额，额满即止；",
    },
    receivedDialog: {
      language_1:
        "*奖励将以兑换码形式于公测后在本活动页面发放，须使用RASTAR GAMES账号登录活动页领取",
    },
    speedRankingDialog: {
      language_1: "活动区服范围：",
      language_2: "排名",
      language_3: "区服",
      language_4: "联盟名",
      language_5: "用时",
      language_6: "数据更新于：",
      language_7: "分",
      language_8: "秒",
    },
  },
};
